<template>
	<div class="table-field">
		<div class="table-container">
			<table class="data-table">
				<thead>
					<tr>
						<th v-for="(column, colIndex) in schema.columns" :key="colIndex">
							{{ column.title }}
						</th>
						<th width="50" v-if="!disabled && canAddRows">Akcje</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
						<td v-for="(column, colIndex) in schema.columns" :key="colIndex">
							<v-textarea
								v-model="row[colIndex]"
								:disabled="disabled"
								@input="updateValue"
								:hide-details="!showValidation || !schema.required || !isFieldEmpty(row[colIndex])"
								:error-messages="showValidation && schema.required && isFieldEmpty(row[colIndex]) ? ['Pole jest wymagane'] : []"
								auto-grow
								rows="1"
								dense
								class="custom-data-table-input"
								/>
							<div class="div-for-print">{{ row[colIndex] }}</div>
						</td>
						<td v-if="!disabled && canAddRows" class="text-center">
							<v-btn
								icon
								small
								@click="removeRow(rowIndex)"
								:disabled="tableData.length <= 1"
								class="delete-row-btn"
							>
								<v-icon small color="red">delete</v-icon>
							</v-btn>
						</td>
					</tr>
				</tbody>
			</table>
			
			<div v-if="!disabled && canAddRows" class="mt-2">
				<v-btn
					small
					color="primary"
					@click="addRow"
					:disabled="!canAddMoreRows"
				>
					Dodaj wiersz
				</v-btn>
				<span v-if="schema.maxRows > 0" class="ml-2 caption">
					({{ tableData.length }}/{{ schema.maxRows }})
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { abstractField } from "vue-form-generator";

	export default {
		name: "customTable",
		
		mixins: [abstractField],
		
		data() {
			return {
				tableData: [],
				showValidation: false
			};
		},
		
		computed: {
			canAddRows() {
				return this.schema.columns && this.schema.columns.length > 0;
			},
			
			canAddMoreRows() {
				if (this.schema.maxRows <= 0) return true; // Bez limitu
				return this.tableData.length < this.schema.maxRows;
			}
		},
		
		mounted() {
			this.initializeTable();
		},
		
		watch: {
			value: {
				handler() {
					this.loadFromValue();
				},
				immediate: true
			}
		},
		
		methods: {
			initializeTable() {
				if (!this.value || !Array.isArray(this.value) || this.value.length === 0) {
					// Dodaj pierwszy pusty wiersz
					this.addRow();
				} else {
					this.loadFromValue();
				}
			},
			
			loadFromValue() {
				if (this.value && Array.isArray(this.value)) {
					this.tableData = this.value.map(row => {
						const newRow = [];
						for (let i = 0; i < this.schema.columns.length; i++) {
							newRow[i] = row[i] || '';
						}
						return newRow;
					});
				} else {
					this.tableData = [];
					this.addRow();
				}
			},
			
			addRow() {
				const newRow = [];
				for (let i = 0; i < this.schema.columns.length; i++) {
					newRow[i] = '';
				}
				this.tableData.push(newRow);
				this.updateValue();
				this.clearValidation();
			},
			
			removeRow(index) {
				if (this.tableData.length > 1) {
					this.tableData.splice(index, 1);
					this.updateValue();
					this.clearValidation();
				}
			},
			
			updateValue() {
				this.value = [...this.tableData];
			},
			
			clearValidation() {
				this.showValidation = false;
			},
			
			isFieldEmpty(value) {
				return value === null || value === undefined || value === '';
			},
			
			validate() {
				this.showValidation = true;
				
				// Walidacja dla pól wymaganych
				if (this.schema.required) {
					if (!this.value || !Array.isArray(this.value) || this.value.length === 0) {
						return ["Tabela jest wymagana!"];
					}
					
					// Sprawdź czy wszystkie wiersze są wypełnione
					for (let i = 0; i < this.value.length; i++) {
						const row = this.value[i];
						if (!row || row.some(cell => cell === null || cell === undefined || cell === '')) {
							return ["Wszystkie komórki w tabeli muszą być wypełnione!"];
						}
					}
				}
				
				return [];
			}
		}
	};
</script>

<style scoped>
	.table-field {
		margin: 10px 0;
		width: 100%;
	}
	
	.field-description {
		color: #666;
		font-size: 14px;
		margin-bottom: 10px;
	}
	
	.table-container {
		width: 100%;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
		padding: 10px;
	}
	
	.data-table {
		width: 100%;
		border-collapse: collapse;
	}
	
	.data-table th {
		background-color: #f5f5f5;
		padding: 8px;
		text-align: left;
		font-weight: bold;
		border-bottom: 2px solid #ddd;
	}
	
	.data-table td {
		padding: 4px;
		border-bottom: 1px solid #eee;
		word-break: break-word;
		white-space: normal;
	}
	
	.data-table td.text-center {
		width: 40px;
		padding: 0;
		vertical-align: middle;
		text-align: center;
	}
	
	.data-table .v-text-field {
		margin: 0;
		padding: 0;
	}
	
	.delete-row-btn {
		background-color: white !important;
	}
	
	.delete-row-btn .v-icon {
		margin-left: -24px !important;
	}
	
	.delete-row-btn:hover {
		background-color: #ffebee !important;
	}

</style>